<template>
  <v-dialog v-model="computedDialog" persistent v-bind="computedDialogProps">
    <template v-if="!noActivator" #activator="{ on }">
      <slot name="activator" :on="on">
        <v-tooltip top :disabled="!tooltip">
          <template #activator="{ on: tooltipOn }">
            <v-btn
              v-if="icon"
              icon
              v-on="{ ...on, ...tooltipOn }"
              :large="large"
              :disabled="disabled"
            >
              <v-icon>{{ icon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ tooltip }}</span>
        </v-tooltip>
      </slot>
    </template>
    <v-form ref="form" @submit.prevent="submitForm">
      <v-card>
        <v-card-title v-if="title">
          <span class="text-h5">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-alert :value="error" transition="scale-transition">
            {{ error }}
          </v-alert>
          <slot :item="value"></slot>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Close</v-btn>
          <v-btn
            color="blue darken-1"
            text
            type="submit"
            :disabled="disableSubmit"
            :loading="saveInProgress"
          >
            {{ submitText }}
          </v-btn>
          <slot name="append-actions"></slot>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogForm",
  components: {},
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    submit: {
      type: Function,
      required: false,
      default: () => null,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
    maxWidth: {
      type: [String, Number],
      required: false,
      default: "300px",
    },
    submitText: {
      type: String,
      required: false,
      default: "Save",
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    tooltip: {
      type: String,
      required: false,
      default: null,
    },
    dialog: {
      type: Boolean,
      required: false,
      default: null,
    },
    noActivator: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableSubmit: {
      type: Boolean,
      required: false,
      default: false,
    },
    dialogProps: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogState: false,
      saveInProgress: false,
      error: null,
    };
  },
  computed: {
    form() {
      return this.$refs.form;
    },
    computedDialog: {
      get() {
        return this.dialog === null ? this.dialogState : this.dialog;
      },
      set(v) {
        this.dialogState = v;
        this.$emit("update:dialog", v);
      },
    },
    computedDialogProps() {
      return { ...(this.maxWidth ? { "max-width": this.maxWidth } : {}), ...this.dialogProps };
    },
  },
  watch: {
    computedDialog(val) {
      if (val) {
        this.$emit("open");
      } else {
        this.$emit("close");
      }
    },
  },
  methods: {
    submitForm() {
      if (this.form.validate()) {
        this.saveInProgress = true;
        return this.submit()
          .then(() => {
            this.saveInProgress = false;
            this.error = null;
            this.form.resetValidation();
            this.closeDialog();
          })
          .catch((err) => {
            this.saveInProgress = false;
            this.error = err;
          });
      }
      return null;
    },
    openDialog() {
      this.computedDialog = true;
    },
    closeDialog() {
      this.computedDialog = false;
    },
  },
};
</script>

<style></style>
